<template>
	<div class="container-fluid dashboard-main-page dashboard-list-page">
		<form @submit.prevent id="header-search" class="header-search-wrapper mt-4 d-flex justify-content-end">
			<input v-model="search" class="header-search-input form-control" @input="liveSearch"
				:placeholder="'Search' | translate" />

			<div v-if="page === 'student' || page === 'parent'" class="header-search-filler" />
		</form>
		<Franchise @deleteUser="deleteUser" @addNewProfile="addNewProfile" @openModal="openModal"
			v-if="page === 'master franchise' || page === 'franchise'" />
		<Teacher @deleteUser="deleteUser" @addNewProfile="addNewProfile" @openModal="openModal" v-if="page === 'teacher'" />
		<Group @deleteUser="deleteUser" @addNewProfile="addNewProfile" @openModal="openModal" v-if="page === 'group'" />
		<Student @addNewProfile="addNewProfile" @deleteUser="deleteUser" @openModal="openModal" @refetchList="getList"
			v-if="page === 'student'" />
		<Parent @deleteUser="deleteUser" @addNewProfile="addNewProfile" @openModal="openModal" v-if="page === 'parent'" />
		<div class="container">
			<div class="d-flex btn-group justify-content-end">
				<button @click="paginate(-1)" v-if="pageNumber > 1" class="btn btn-outline-primary">
					{{ 'Previous' | translate }}
				</button>
				<button @click="paginate(1)" v-if="$store.state.profiles.length >= 20" class="btn btn-outline-primary">
					{{ 'Next' | translate }}
				</button>
			</div>
		</div>
		<ModalEmail :show="showModal" @close="showModal = false"></ModalEmail>
		<ModalLessons :show="showModalLessons" @close="showModalLessons = false"></ModalLessons>
		<ModalBonus :show="showModalBonus" @close="showModalBonus = false"></ModalBonus>
		<ModalDelete :show="showModalDelete" @close="showModalDelete = false" @deleteUser="deleteUser"></ModalDelete>
	</div>
</template>

<script>
import Franchise from './Franchise.vue'
import Teacher from './Teacher.vue'
import Group from './Group.vue'
import Student from './Student.vue'
import Parent from './Parent.vue'

import ModalEmail from '../Modal/Email.vue'
import ModalDelete from '../Modal/Delete.vue'
import ModalBonus from '../Modal/Bonus.vue'
import ModalLessons from '../Modal/Lessons.vue'

export default {
	name: 'List',
	data() {
		return {
			timeoutId: null,
			search: '',
			pageNumber: 1,
			myRole: this.$store.state.myProfile.role,
			showModal: false,
			showModalBonus: false,
			showModalDelete: false,
			showModalLessons: false,
		}
	},
	components: {
		Franchise,
		Student,
		Teacher,
		Parent,
		Group,
		ModalEmail,
		ModalBonus,
		ModalDelete,
		ModalLessons,
	},
	computed: {
		page() {
			return this.$route.params.role
		},
	},
	methods: {
		liveSearch() {
			clearInterval(this.timeoutId)
			this.timeoutId = setTimeout(() => {
				this.getList(this.search && true)
			}, 1000)
		},
		paginate(page) {
			this.pageNumber += page
			this.getList()
		},
		openModal() {
			let modalType = this.$store.state.modalType
			if (modalType === 'bonus') {
				this.showModalBonus = true
				return true
			} else if (modalType === 'delete') {
				this.showModalDelete = true
				return true
			} else if (modalType === 'lessons') {
				this.showModalLessons = true
				return true
			}
			this.showModal = true
		},

		getList(isSearch) {
			this.$store.commit('changeProfiles', {})

			const roles = {
				student: 'students',
				teacher: 'teachers',
				parent: 'parents',
			}

			let url = ''

			const query = this.$route.query

			if (this.page === 'group') {
				url = `groups/?page=${this.pageNumber}`

				if (isSearch) {
					url = `${url}&q=${this.search}`
				} else {
					url = `${url}&step=21${query.parent ? `&parent=${query.parent}` : ''}`
				}
			} else {
				url = `users/${roles[this.page]}` //`users?role=${this.page}`

				if (this.page.includes('franchise')) {
					if (this.page == 'franchise') {
						url = `users/franchises?role=franchise`
					}

					if (this.page == 'master franchise') {
						url = `users/franchises?role=master franchise`
					}

					if (query.parent) {
						url = `${url}&parent=${query.parent}`
					}
				}

				if (isSearch) {
					if (this.page.includes('franchise')) {
						url = `${url}&search=${this.search}`
					} else {
						url = `${url}?search=${this.search}`
					}
				}

				if (
					this.$route.params.type === 'deactivated' &&
					this.page === 'student'
				) {
					url += '&deactivated=true'
				}

				if (query.parent && !this.page.includes('franchise')) {
					url = `${url}${url.includes('?') ? '&' : '?'}parent=${query.parent}${query.is_active ? '&is_active=false' : ''
						}`
				} else if (query.group) {
					url = `${url}${url.includes('?') ? '&' : '?'}group=${query.group
						}&page=${this.pageNumber}`
				} else if (!isSearch) {
					if (this.page.includes('franchise')) {
						url = `${url}&page=${this.pageNumber}`
					} else {
						url = `${url}${url.includes('?') ? '&' : '?'}page=${this.pageNumber
							}`
					}
					//`${url}?page=${this.pageNumber}&step=21`
				}
			}
			this.axios({
				url: encodeURI(url),
			}).then(resp => {
				let result = null

				if (this.page === 'group') {
					result = resp.data
				} else {
					result = resp.data.results
				}

				this.$store.commit('changeProfiles', result)
			})
		},
		addNewProfile() {
			this.$router.push({
				name: 'Dashboard Add',
				params: { role: this.$route.params.role },
			})
		},
		deleteUser() {
			let delUrl = `users/user/${this.$store.state.modalId[0]}`
			if (this.page === 'group') {
				delUrl = `groups/${this.$store.state.modalId[0]}`
			}

			this.axios({
				method: 'delete',
				url: delUrl,
			}).then(response => {
				this.showModalDelete = false
				this.getList()
			})
		},
	},
	watch: {
		$route(from, to) {
			if (to.params.role !== from.params.role) {
				this.pageNumber = 1
				this.search = ''
			}
			this.getList()
		},
	},
	beforeMount() {
		this.getList()
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.header-search-wrapper {
	position: relative;
	margin: 0 20px;
}

.header-search-filler {
	height: 40px;
}

.header-search-input {
	position: absolute;
	top: 0;
	right: 8%;

	z-index: 1;

	width: 300px;
}

.btn-primary {
	background-color: #e69c50;
	color: #313131;
}

.btn-primary:hover {
	background-color: #f5d001;
}

table a {
	display: block;
}

table {
	margin-top: 20px;
}

.btn {
	margin: 10px 10px 10px 0;
}

th {
	cursor: pointer;
	border-top: none;
	color: #78909c;
	text-transform: uppercase;
}

tr {
	transition: 0.3s;
}

tr:not(:first-child):hover {
	box-shadow: 0px 0px 10px -1px rgba(0, 0, 0, 0.3);
}

th:hover {
	color: #01b9d1;
}

span {
	color: #78909c;
}
</style>
